// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// Example: EQUALS

export const MatchModeSchema = t.keyof({
  EQUALS: null,
  EQUALS_IGNORE_CASE: null,
  CONTAINS_IGNORE_CASE: null,
});

export type MatchMode = t.TypeOf<typeof MatchModeSchema>;
